module.exports = __webpack_public_path__ + "img/category-brand-hover.6dbd1970.png";